import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandlerInterface } from './error-handler.interface';

@Injectable()
export class GenericErrorHandlerService implements ErrorHandlerInterface {
  constructor(
    private translateService: TranslateService,
    private toastService: ToastrService,
  ) {}
  handleError(error: any): boolean {
    if (error.status >= 500 && error.status < 600) {
      this.toastService.error(
        this.translateService.instant('PORTAL-SETTINGS.ERROR-MESSAGE'),
      );
      // Handle the 404 error here if needed.
      return true;
    }
    return false;
  }
}
